export const FETCH_WATER_SYSTEMS_REQUEST = "FETCH_WATER_SYSTEMS_REQUEST";
export const FETCH_WATER_SYSTEMS_SUCCESS = "FETCH_WATER_SYSTEMS_SUCCESS";
export const FETCH_WATER_SYSTEMS_FAILURE = "FETCH_WATER_SYSTEMS_FAILURE";

export const fetchWaterSystemRequest = () => {
  return {
    type: FETCH_WATER_SYSTEMS_REQUEST,
  };
};
export const fetchWaterSystemSuccess = (data) => {
  return {
    type: FETCH_WATER_SYSTEMS_SUCCESS,
    payload: data,
  };
};
export const fetchWaterSystemFailure = (error) => {
  return {
    type: FETCH_WATER_SYSTEMS_FAILURE,
    payload: error,
  };
};
